import React, { useEffect, useState } from 'react';
import { message, Card, Drawer, Tabs, Table } from "antd";
import { MDBCol, MDBRow } from "mdbreact";
import { Text } from "react-font";
import { Badge, Button, SearchInput } from "evergreen-ui";
import Firebase from "../../Firebase/Firebase";
import FireFetch from "../../Firebase/FireFetch";
import { TableExport } from "tableexport";
import { useListVals } from "../../Firebase/databaseHooks";
import AddGroup from "../../Modals/Groups/AddGroup";
import EditGroup from "../../Modals/Groups/EditGroup";
import { getDatabase, ref } from "firebase/database";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import ViewGroup from "../../Modals/Groups/ViewGroup";
import GroupPie from "./GroupPie";
import { getDownloadURL, getStorage, listAll, ref as storageRef } from "firebase/storage";
import { useAuth } from "../../AuthContext/AuthContext";
import TableActionMenu from "../../Common/TableActionMenu";

const compareText = (a, b) => String(a ?? "").localeCompare(String(b ?? ""));
const columns = [

	{
		title: 'Group Name',
		dataIndex: 'groupName',
		key: 'groupName',
		sorter: (a, b) => compareText(a.groupName, b.groupName)
	},
	{
		title: 'Calls Self',
		dataIndex: 'callsSelf',
		key: 'callsSelf',
		sorter: (a, b) => compareText(a.callsSelf, b.callsSelf)
	},
	{
		title: 'Community',
		dataIndex: 'community',
		key: 'community',
		sorter: {
			compare: (a, b) => compareText(a.community, b.community),
		},
	},
	{
		title: 'Type',
		dataIndex: 'groupType',
		key: 'groupType',
		sorter: {
			compare: (a, b) => compareText(a.groupType, b.groupType),
		},
	},
	{
		title: 'Organisation',
		dataIndex: 'organisation',
		key: 'orgID',
		sorter: {
			compare: (a, b) => compareText(a.orgID, b.orgID),
		},
	},
	{
		title: 'Start Date',
		dataIndex: 'created',
		key: 'created',
		sorter: (a, b) => compareText(a.created, b.created)
	},
	{
		title: 'Responsible',
		key: 'responsible',
		dataIndex: 'responsible',
		responsive: ["sm"],
		sorter: (a, b) => compareText(a.responsible, b.responsible)

	},
	{
		title: 'Group Status',
		dataIndex: 'status',
		key: 'status',
		sorter: (a, b) => compareText(a.groupStatus, b.groupStatus)
	},
	{
		title: 'Created By',
		key: 'createdBy',
		dataIndex: 'createdBy',
		responsive: ["sm"],
		sorter: (a, b) => compareText(a.createdBy, b.createdBy)
	},
	{
		title: 'Action',
		key: 'action',
		dataIndex: 'action',
	},
];

const db = getDatabase(Firebase);
const auth = getAuth(Firebase);
const storage = getStorage(Firebase);

const Groups = () => {
	const { canAccessModule } = useAuth();
	const canCreateGroup = canAccessModule("GROUPS", "create");
	const canUpdateGroup = canAccessModule("GROUPS", "update");
	const canDeleteGroup = canAccessModule("GROUPS", "delete");
	const [dataArray, setDataArray] = useState([]);
	const [eventsData, setEventsData] = useState([]);
	const [groupArray, loading] = useListVals(ref(db, "talmidsdb/groups"));
	const [userArray] = useListVals(ref(db, "talmidsdb/users"));
	const [organizationArray] = useListVals(ref(db, "talmidsdb/organisations"));
	const [communityArray] = useListVals(ref(db, "talmidsdb/communities"));
	const [districtArray] = useListVals(ref(db, "talmidsdb/district"));
	const [languageArray] = useListVals(ref(db, "talmidsdb/languages"));
	const [groupTypeArray] = useListVals(ref(db, "talmidsdb/groupTypes"));
	const [showModal, setShowModal] = useState(false);
	const [viewModal, setViewModal] = useState(false);
	const [selectedGroup, setSelectedGroup] = useState(null);
	const [viewGroup, setViewGroup] = useState(null);
	const [editModal, setEditModal] = useState(false);

	useEffect(() => {
		setEventsData([]);
		setDataArray([]);
		const tempArray = [];

		const unsubscribe = onAuthStateChanged(auth, (user) => {
			if (user) {
				if (groupArray?.length) {
					groupArray.forEach((item, index) => {
						const groupId = item?.id ?? item?.groupId;

						if (groupId && (!item?.photos || Object.keys(item.photos).length === 0)) {
							const urlArray = [];
							listAll(storageRef(storage, `groups/${groupId}`))
								.then((res) => {
									res.items.forEach((itemRef) => {
										getDownloadURL(itemRef).then((url) => {
											urlArray.push(url);
											const picObj = { photos: urlArray };
											FireFetch.UpdateInDB("groups", groupId, picObj);
										});
									});
								})
								.catch(() => { });
						}

						const createdByUser = userArray.find((x) => x.id === item?.addedByUser);
						const responsibleUser = userArray?.find((x) => x.id === item?.responsibleUserID);
						const districtName = districtArray?.find((x) =>
							x.id === item?.districtID ||
							x.districtID === item?.districtID ||
							x.id === item?.district ||
							x.districtID === item?.district
						)?.districtName;
						const communityName = communityArray?.find((x) =>
							x.id === item?.communityID ||
							x.communityID === item?.communityID ||
							x.id === item?.community ||
							x.communityID === item?.community
						)?.name;
						const organisationName = organizationArray.find((x) =>
							x.id === item?.orgID ||
							x.orgID === item?.orgID ||
							x.id === item?.organisation ||
							x.orgID === item?.organisation
						)?.name;
						const primaryContact = userArray.find((x) => x.id === item?.primaryContactName);
						const secondaryContact = userArray.find((x) => x.id === item?.secondaryContactName);

						const row = {
							key: index + 1,
							groupId,
							groupName: item?.groupSelfName ?? item?.groupName ?? "-",
							groupSelfName: item?.groupSelfName ?? item?.groupName ?? "-",
							groupCallsSelf: item?.groupCallsSelf ?? item?.groupSelfName ?? item?.groupName ?? "",
							createdBy: createdByUser ? `${createdByUser.firstname ?? ''} ${createdByUser.surname ?? ''}`.trim() : item?.addedByUser,
							responsible: responsibleUser ? `${responsibleUser.firstname ?? ''} ${responsibleUser.surname ?? ''}`.trim() : '-',
							responsibleUser: item?.responsibleUserID ?? item?.responsibleUser,
							groupStatus: item?.groupStatus ?? "",
							status: <Badge color={item?.groupStatus === "Inactive" ? "neutral" : "green"}>{item?.groupStatus ?? "-"}</Badge>,
							organisation: organisationName,
							orgID: item?.orgID ?? item?.organisation,
							community: communityName,
							communityID: item?.communityID ?? item?.community,
							callsSelf: item?.groupSelfName ?? item?.groupName ?? "-",
							dueDate: item?.dueDate,
							created: item?.yearEstablished ? String(item.yearEstablished) : (item?.groupStartDate ? String(item.groupStartDate) : ""),
							activeMen: item?.activeMen,
							activeWomen: item?.activeWomen,
							district: districtName ?? districtArray?.find((x) => x.id === item?.districtID || x.districtID === item?.districtID)?.district,
							districtID: item?.districtID ?? item?.district,
							countryID: item?.countryID ?? item?.country,
							genderDemographics: item?.genderDemographics,
							groupPrimaryLanguage: item?.groupPrimaryLanguage,
							primaryLanguage: languageArray?.find((x) => x.id === item?.groupPrimaryLanguage || x.languageID === item?.groupPrimaryLanguage)?.languageName
								?? languageArray?.find((x) => x.id === item?.groupPrimaryLanguage || x.languageID === item?.groupPrimaryLanguage)?.language,
							hasCompletedByLaws: item?.hasCompletedByLaws,
							groupTypeId: item?.groupTypeId ?? item?.groupType,
							groupType: groupTypeArray?.find((x) => x.id === item?.groupTypeId || x.typeID === item?.groupTypeId)?.typeName
								?? groupTypeArray?.find((x) => x.id === item?.groupTypeId || x.typeID === item?.groupTypeId)?.type,
							marketDay: item?.marketDay,
							meetingDays: item?.meetingDays,
							groupStartDate: item?.groupStartDate ?? item?.yearEstablished,
							groupEndDate: item?.groupEndDate,
							groupPurposeObjective: item?.groupPurposeObjective,
							notes: item?.notes,
							salesforceID: item?.salesforceID,
							addedByUser: item?.addedByUser,
							dateCreated: item?.dateCreated,
							dateModified: item?.dateModified,
							primaryContactName: primaryContact ? `${primaryContact.firstname ?? ""} ${primaryContact.surname ?? ""}`.trim() : item?.primaryContactName,
							secondaryContactName: secondaryContact ? `${secondaryContact.firstname ?? ""} ${secondaryContact.surname ?? ""}`.trim() : item?.secondaryContactName,
							action: (
								<TableActionMenu
									items={[
										{
											key: "view",
											label: "View",
											onClick: () => {
												setViewGroup(item);
												setViewModal(true);
											},
										},
										canUpdateGroup && {
											key: "edit",
											label: "Edit",
											onClick: () => {
												setSelectedGroup({
													...item,
													groupId,
													groupName: item?.groupSelfName ?? item?.groupName ?? "-",
													organisation: item?.orgID ?? item?.organisation,
													community: item?.communityID ?? item?.community,
													country: item?.countryID ?? item?.country,
													district: item?.districtID ?? item?.district,
													groupType: item?.groupTypeId ?? item?.groupType,
													responsibleUser: item?.responsibleUserID ?? item?.responsibleUser
												});
												setEditModal(true);
											},
										},
										canDeleteGroup && {
											key: "delete",
											label: "Delete",
											danger: true,
											onClick: async () => {
												if (!canDeleteGroup) {
													message.error("You do not have permission to delete groups.");
													return;
												}
												if (!groupId) {
													message.error("Unable to delete this group: missing group ID.");
													return;
												}
												if (!confirm("Are you sure you want to delete this group?")) {
													return;
												}

												try {
													const response = await FireFetch.DeleteFromDB("groups", groupId);
													if (response === "success") {
														await FireFetch.addLog("groups", groupId, "Delete");
														message.success("Group deleted successfully");
													} else {
														message.error("Unable to delete the group. Please try again.");
													}
												} catch (error) {
													console.error("Delete error:", error);
													message.error("Something went wrong while deleting the group.");
												}
											},
										},
									]}
								/>
							)
						};

						tempArray.push(row);
					});
					setEventsData([...tempArray]);
					setDataArray([...tempArray]);
				}
			} else {
				// No user is signed in.
				window.location.href = "/login";
			}
		});

		return () => unsubscribe();
	}, [groupArray, userArray, organizationArray, communityArray, districtArray, languageArray, groupTypeArray, canUpdateGroup, canDeleteGroup]);

	const handleSearch = (searchText = "") => {
		const search = String(searchText).toLowerCase();
		const filteredEvents = dataArray.filter(({ groupName, callsSelf, community, groupType, organisation, created, responsible, groupStatus }) => {
			const values = [groupName, callsSelf, community, groupType, organisation, created, responsible, groupStatus];
			return values.some((value) => String(value ?? "").toLowerCase().includes(search));
		});
		setEventsData(filteredEvents);
	};

	const items = [
		{
			key: '1',
			label: `Table`,
			children:
				<div className="d-flex flex-column my-1">
					<div className="d-flex flex-row align-self-end py-2">
						<SearchInput placeholder="Filter through groups" onChange={e => handleSearch(e.target.value)} />
						{canCreateGroup && (
							<Button appearance="primary" className="mx-1" onClick={() => { setShowModal(true) }}>
								New Group
							</Button>
						)}
						<Button appearance="primary" className="mx-1" onClick={() => {
							FireFetch.exportXL(TableExport(document.getElementById("dataTable"), {
								filename: "Groups",
								exportButtons: false,
								sheetname: "Groups",
							}), eventsData);
						}}>
							Print
						</Button>
					</div>
					<Table id="dataTable" className="custom-table" style={{ overflow: "auto" }}
						pagination={{ defaultPageSize: 100, showSizeChanger: true, pageSizeOptions: ['100', '200', '300'] }}
						loading={loading} columns={columns} dataSource={eventsData} />
				</div>,
		},
		{
			key: '2',
			label: `Pivots`,
			children:
				<GroupPie modal={viewModal} setModal={setViewModal} setGroup={setSelectedGroup} />
			,
		},
	];

	return (
		<div className="d-flex justify-content-center align-items-center pt-4 mt-4">
			<Drawer title="New Group"
				width={500}
				maskClosable
				className="font-Nunito"
				placement="right" onClose={() => { setShowModal(false) }}
				visible={showModal}>
				<AddGroup modal={setShowModal} />
			</Drawer>
			<Drawer
				title={`${selectedGroup?.groupName}`}
				width={500}
				maskClosable
				className="font-Nunito"
				placement="right"
				visible={editModal}
				onClose={() => { setEditModal(false) }}
			>
				<EditGroup modal={setEditModal} group={selectedGroup} />
			</Drawer>
			<Drawer
				title={`${viewGroup?.groupName ?? viewGroup?.groupSelfName ?? "-"}`}
				width={800}
				maskClosable
				className="font-Nunito"
				placement="right"
				visible={viewModal}
				onClose={() => { setViewModal(false) }}
			>
				<ViewGroup group={viewGroup} />
			</Drawer>
			<MDBRow className="w-100">
				<MDBCol md={12}>
					<Card className="w-100">
						<MDBRow>
							<MDBCol md={12}>
								<div className="text-left">
									<div className="d-flex flex-row justify-content-between">
										<div className="d-inline">
											<h5 className="font-weight-bold" style={{ color: '#51195D' }}>
												<Text family='Nunito'>
													Groups
												</Text>
											</h5>
										</div>
									</div>
								</div>
							</MDBCol>
						</MDBRow>
					</Card>
					<Card>
						<Tabs type={"card"} items={items} onChange={() => { }} />
					</Card>
				</MDBCol>
			</MDBRow>
		</div>
	);
}

export default Groups;
